import React from 'react';
import './Gallery.css';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

// Separate SlideShow component
const SlideShow = ({ images, title }) => {
  const [currentIndex, setCurrentIndex] = React.useState(0);

  const goToPrevious = () => {
    const isFirstImage = currentIndex === 0;
    const newIndex = isFirstImage ? images.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const goToNext = () => {
    const isLastImage = currentIndex === images.length - 1;
    const newIndex = isLastImage ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  return (
    <div className="slideshow-section">
      <h3>{title}</h3>
      <div className="slideshow-container">
        <div className="arrow left-arrow" onClick={goToPrevious}>
          <ArrowBackIosIcon />
        </div>

        <div className="slide-frame">
          {images.length > 0 ? (
            <iframe
              src={`https://drive.google.com/file/d/${images[currentIndex]}/preview`}
              className="slide-image"
              frameBorder="0"
              allowFullScreen
            ></iframe>
          ) : (
            <div className="no-images">No images available</div>
          )}
        </div>

        <div className="arrow right-arrow" onClick={goToNext}>
          <ArrowForwardIosIcon />
        </div>
      </div>

      <div className="dot-indicators">
        {images.map((_, index) => (
          <span 
            key={index} 
            className={`dot ${index === currentIndex ? 'active-dot' : ''}`}
            onClick={() => setCurrentIndex(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

// Main Gallery component
const Gallery = () => {
  const gbmImages = [
    "1pWt20GAeoHqYgEE6Wo3va0xeY0P1VrIs",
    "1tx_pSoqxFwqX20ahqtNozPHKIKkwxPRq",
    "1C-3w0QfCE9gz2AXq5zH-CeP2nNuLJL7f",
    "1V3rhoKi-TsMaxobzdEO5ZBDak-xW1e5X",
    "1wzdYBcWaqKlLGeIjnaRx1BRil5Ord0ic"
  ];

  const socialImages = [
    "13yHxbpMSA-nJF1jPBa-yncUR8K4UVkeS",
    "1eOa2n0wAknYLrR-yY-hd4_j8szDQGthW",
    "1ruw5VXwVF8P55cfn79mmMBma3j_42ibJ",
    "1kB1TbRIgLc5u0hoR9k5FzZnIXpcHvkMj",

  ];

  const companyImages = [
    "1Fmg-VyMIm3hnrAmNJPXZKDGh5iPWc85e",
    "1lLFCi5MWRDitTtimuuOdr7yKnjnOpqt0",
    "19_M5ZRvvREcsOKCK_sjPG8kVtPweT2Dp"
  ];

  return (
    <div className="gallery-container">
      <h2 className="header-title">WECE Gallery</h2>
      <div className="content-wrapper">
        <SlideShow 
          images={gbmImages}
          title="GBMs"
        />

        <SlideShow 
          images={socialImages}
          title="Socials"
        />

        <SlideShow 
          images={companyImages}
          title="Company Events"
        />
      </div>

      <div className="blackText">
        <p>Check out our Instagram for more photos!</p>
      </div>
    </div>
  );
};

export default Gallery;
